// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Chartkick from 'vue-chartkick'


Vue.config.productionTip = true;
Vue.use(Chartkick);
/*
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const publicPages = ['/connexion', '/changement_mots_de_passe', '/first_co'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  if (authRequired && !loggedIn) {
    
    for (let index = 0; index < publicPages.length-1; index++) {
      const regex1 = /first_co/i;
      const regex2 = /changement_mots_de_passe/i;
      console.log(to.path.search(regex1));
      if (to.path.search(regex1) == 1){
        return next();
      }else if (to.path.search(regex2) == 1){
        return next();
      }
    }
      console.log('ko', to.path);
      return next('/connexion');
  }
  next();
})*/
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js